import React from 'react';
import Modal from '@mui/material/Modal';
import { useRouter } from 'next/router';
import MuiButton from 'components/Common/MuiButton';
import Icon from 'components/Common/Icon';
import i18n from 'locales/fa.json';
import { StyledModal } from 'components/Wallet/Basket/style';

const UpdatePopup: React.FC<{
  isOpen: boolean;
  setOpen: (status: boolean) => void;
}> = ({ isOpen, setOpen }) => {
  const router = useRouter();

  return (
    <Modal open={isOpen} onClose={(): void => setOpen(false)}>
      <StyledModal>
        <Icon
          name="x-close"
          fontSize={5}
          color="ash60"
          onClick={(): void => setOpen(false)}
          position="absolute"
          top={5}
          left={5}
        />
        <p>{i18n.global.updateModal.updateMessage}</p>
        <MuiButton onClick={(): void => router.reload()}>
          {i18n.global.updateModal.updateBtn}
        </MuiButton>
      </StyledModal>
    </Modal>
  );
};
export default UpdatePopup;
